import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';
import { Button, Tooltip, Typography, withStyles, WithStyles } from '@material-ui/core';
import { createStyles, Theme } from '@material-ui/core/styles';
import { compose } from 'recompose';
import FieldLabel from './FieldLabel';

const styles = createStyles({
  selectBox: {
    backgroundColor: '#d6d6d6',
    border: 'solid 1px rgb(187, 187, 187)',
    paddingTop: '15px',
    paddingBottom: '15px',
    paddingLeft: '3px',
    paddingRight: '0px',
    fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
    fontSize: '15px',
    color: 'rgb(78, 78, 78)',
    fontWeight: 400,
    width: '100%',
  },
  label: {
    fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
    color: 'rgb(102, 102, 102)',
    fontSize: '15px',
    fontWeight: 700,
    webkitFontSmoothing: 'antialiased',
    display: 'inline-block',
    lineHeight: '19.5px',
    marginRight: '5px',
    marginTop: '18px',
    marginBottom: '12px',
  },
  required: {
    color: '#d50000',
    padding: '5px',
  },
  select: {},
  labelArea: {
    display: 'flex',
    alignITems: 'center',
  },
});

interface Option {
  text: string;
  value: string;
}

interface OwnProps {
  label?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  options: Option[];
  formControlClassName?: string;
  directError?: boolean;
  requireMark?: boolean;
  toolTipHtml?: string;
}

type Props = OwnProps & WrappedFieldProps;

class FormSelectField extends React.PureComponent<Props & WithStyles<typeof styles>> {
  render() {
    const {
      meta,
      input,
      label,
      fullWidth,
      disabled,
      options,
      directError,
      classes,
      requireMark,
      toolTipHtml,
    } = this.props;
    const { error, touched, dirty, invalid } = meta;
    const inErrorState = invalid && (touched || dirty || directError);
    return (
      <div>
        <div className={classes.labelArea}>
          {label && (
            <FieldLabel
              text={label}
              required={requireMark}
              error={inErrorState}
              errorText={error}
              toolTipHtml={toolTipHtml}
            />
          )}
        </div>
        <div>
          <select disabled={disabled} {...input} className={classes.selectBox}>
            {options.map((item, idx) => {
              return (
                <option key={idx} value={item.value}>
                  {item.text}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    );
  }
}

export default compose<Props & WithStyles<typeof styles>, Props>(withStyles(styles))(FormSelectField);



// WEBPACK FOOTER //
// ./src/components/FormSelectField.tsx